export interface serviceFormOptions {
  /** The service id to edit */
  serviceId: string;
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Service Form page in the dashboard.
 * @dashobardPageBuilder
 */
export function serviceForm(options: serviceFormOptions): PageBuilderResult {
  const { serviceId } = options;

  return {
    pageId: 'db6319e8-f8d6-4de3-830e-917d4e5c6d47',
    relativeUrl: `${serviceId}`,
  };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Export Booking Data page in the dashboard.
 * @dashobardPageBuilder
 */
export function exportBookingData(): PageBuilderResult {
  return {
    pageId: 'bbbc8c7d-19b9-4a86-bfc5-1bf59208b01b',
    relativeUrl: `?openModal=exportBookingData`,
  };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Sync Personal Calendar page in the dashboard.
 * @dashobardPageBuilder
 */
export function syncPersonalCalendar(): PageBuilderResult {
  return {
    pageId: 'bbbc8c7d-19b9-4a86-bfc5-1bf59208b01b',
    relativeUrl: `?openModal=syncPersonalCalendar`,
  };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Services List page in the dashboard.
 * @dashobardPageBuilder
 */
export function servicesList(): PageBuilderResult {
  return { pageId: 'c756378f-3438-41c6-a686-85e9fb0193ac' };
}

export interface staffEditOptions {
  /** The staff member id to edit */
  staffMemberId: string;
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Staff Edit page in the dashboard.
 * @dashobardPageBuilder
 */
export function staffEdit(options: staffEditOptions): PageBuilderResult {
  const { staffMemberId } = options;

  return {
    pageId: 'a6a6a0ee-865f-43cc-a8f2-b50984f74457',
    relativeUrl: `${staffMemberId}`,
  };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Staff List page in the dashboard.
 * @dashobardPageBuilder
 */
export function staffList(): PageBuilderResult {
  return { pageId: 'a4f36fac-ea18-483b-8236-095e29fcb726' };
}

export interface PageBuilderResult {
  pageId: string;
  relativeUrl?: string;
}
